import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-180" data-mp="21yd8ya0c84tx">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-electric/40 border-l-4 border-l-electric bg-industrial p-4 pr-10 text-silver shadow-glow-strong" aria-live="polite" data-id="element-181" data-mp="1wyh3e6bzs5c9">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-steel transition-colors duration-150 ease-out hover:text-silver focus:outline-none focus-visible:ring-2 focus-visible:ring-electric" aria-label="Dismiss notice" data-id="element-182" data-mp="1sh7kcrid1u2j">
            <XIcon className="h-4 w-4" data-id="element-183" data-mp="1ng1qgqcys0rf" />
          </button>
          <div className="flex gap-3" data-id="element-184" data-mp="1nio0cwnbusct">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-185" data-mp="19p4yn1qv3nlf" />
            <div data-id="element-186" data-mp="1egen3z0ockvq">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-silver" data-id="element-187" data-mp="1egwsbl5be9fs">Access confirmed</p>
              <p className="mt-1 text-sm leading-snug text-steel" data-id="element-188" data-mp="zt20e6z4s93r">
                Once your purchase is complete you receive the
                <br data-id="element-189" data-mp="qqkc7mzx16e4" />
                <span className="font-bold text-silver" data-id="element-190" data-mp="qq0vuapwyq27">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-steel" data-id="element-191" data-mp="vq5arwb6bcqb">Instant digital access by email</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}